var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "modal-card-body has-text-left" },
      [
        _c("step-tracker"),
        _vm._v(" "),
        _c("h2", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: _vm.langRoot + ".security.title",
              expression: "`${langRoot}.security.title`"
            }
          ],
          staticClass: "step-heading"
        }),
        _vm._v(" "),
        _vm._l(_vm.questions, function(question, index) {
          return _c(
            "div",
            { key: question.id, staticClass: "field question" },
            [
              _c(
                "label",
                {
                  staticClass: "label question__label",
                  attrs: { for: "question-" + question.id }
                },
                [
                  _vm._v(
                    _vm._s(index + 1) +
                      ". " +
                      _vm._s(_vm.$t("accountRecoveryQuestion." + question.id))
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "focus",
                      rawName: "v-focus",
                      value: index === 0,
                      expression: "index === 0"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.answers[question.id],
                      expression: "answers[question.id]"
                    }
                  ],
                  staticClass: "input",
                  attrs: {
                    id: "question-" + question.id,
                    type: "text",
                    "data-ci": "question-" + index,
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.answers[question.id] },
                  on: {
                    change: function($event) {
                      return _vm.$trackEvent(_vm.pageTag, "answer_entered", [
                        index + 1
                      ])
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.answers, question.id, $event.target.value)
                    }
                  }
                })
              ])
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "modal-card-foot" }, [
      _c("div", { staticClass: "level is-block" }, [
        _c("div", { staticClass: "level-right is-pulled-right" }, [
          _c("button", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: _vm.langRoot + ".security.submitBtn",
                expression: "`${langRoot}.security.submitBtn`"
              }
            ],
            staticClass: "btn primary",
            class: { inactive: !_vm.isValid },
            attrs: {
              "data-ci": "pr-step2-next-button",
              disabled: !_vm.isValid
            },
            on: { click: _vm.submit }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "level-left is-pulled-left" },
          [
            _c("router-link", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: _vm.langRoot + ".security.cancelBtn",
                  expression: "`${langRoot}.security.cancelBtn`"
                }
              ],
              staticClass: "btn is-ghost",
              attrs: { to: { name: "passwordreset" } }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59369de2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59369de2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./login/Components/PasswordResetSecurity.vue
// module id = 0Hk7
// module chunks = 1